import style_inject_es_default from "../../../../../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js";

//#region src/components/radio/radiogroup.module.css
var css_248z = ".radiogroup-module_root__-eRIC {\n    display: flex;\n    flex-direction: column;\n    gap: var(--mantine-spacing-sm);\n}\n\n.radiogroup-module_required__HmNU- {\n    /* inline-block strips the leading space in Mantine's hard-coded ' *' asterisk. */\n    display: inline-block;\n}\n";
var radiogroup_module_default = {
	"root": "radiogroup-module_root__-eRIC",
	"required": "radiogroup-module_required__HmNU-"
};
style_inject_es_default(css_248z);

//#endregion
export { radiogroup_module_default as default };